export const setValue = (key, value, entity, setEntity) => {
    let newEntity = {...entity};
    newEntity[key] = value;
    setEntity(newEntity)
}